"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _LineString = _interopRequireDefault(require("../LineString"));

var _GeometryFactory = _interopRequireDefault(require("../GeometryFactory"));

var _IllegalArgumentException = _interopRequireDefault(require("../../../../../java/lang/IllegalArgumentException"));

var _Point = _interopRequireDefault(require("../Point"));

var _Polygon = _interopRequireDefault(require("../Polygon"));

var _MultiPoint = _interopRequireDefault(require("../MultiPoint"));

var _LinearRing = _interopRequireDefault(require("../LinearRing"));

var _MultiPolygon = _interopRequireDefault(require("../MultiPolygon"));

var _GeometryCollection = _interopRequireDefault(require("../GeometryCollection"));

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

var _MultiLineString = _interopRequireDefault(require("../MultiLineString"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var GeometryTransformer =
/*#__PURE__*/
function () {
  function GeometryTransformer() {
    _classCallCheck(this, GeometryTransformer);

    GeometryTransformer.constructor_.apply(this, arguments);
  }

  _createClass(GeometryTransformer, [{
    key: "transformPoint",
    value: function transformPoint(geom, parent) {
      return this._factory.createPoint(this.transformCoordinates(geom.getCoordinateSequence(), geom));
    }
  }, {
    key: "transformPolygon",
    value: function transformPolygon(geom, parent) {
      var isAllValidLinearRings = true;
      var shell = this.transformLinearRing(geom.getExteriorRing(), geom);
      if (shell === null || !(shell instanceof _LinearRing.default) || shell.isEmpty()) isAllValidLinearRings = false;
      var holes = new _ArrayList.default();

      for (var i = 0; i < geom.getNumInteriorRing(); i++) {
        var hole = this.transformLinearRing(geom.getInteriorRingN(i), geom);

        if (hole === null || hole.isEmpty()) {
          continue;
        }

        if (!(hole instanceof _LinearRing.default)) isAllValidLinearRings = false;
        holes.add(hole);
      }

      if (isAllValidLinearRings) return this._factory.createPolygon(shell, holes.toArray([]));else {
        var components = new _ArrayList.default();
        if (shell !== null) components.add(shell);
        components.addAll(holes);
        return this._factory.buildGeometry(components);
      }
    }
  }, {
    key: "createCoordinateSequence",
    value: function createCoordinateSequence(coords) {
      return this._factory.getCoordinateSequenceFactory().create(coords);
    }
  }, {
    key: "getInputGeometry",
    value: function getInputGeometry() {
      return this._inputGeom;
    }
  }, {
    key: "transformMultiLineString",
    value: function transformMultiLineString(geom, parent) {
      var transGeomList = new _ArrayList.default();

      for (var i = 0; i < geom.getNumGeometries(); i++) {
        var transformGeom = this.transformLineString(geom.getGeometryN(i), geom);
        if (transformGeom === null) continue;
        if (transformGeom.isEmpty()) continue;
        transGeomList.add(transformGeom);
      }

      return this._factory.buildGeometry(transGeomList);
    }
  }, {
    key: "transformCoordinates",
    value: function transformCoordinates(coords, parent) {
      return this.copy(coords);
    }
  }, {
    key: "transformLineString",
    value: function transformLineString(geom, parent) {
      return this._factory.createLineString(this.transformCoordinates(geom.getCoordinateSequence(), geom));
    }
  }, {
    key: "transformMultiPoint",
    value: function transformMultiPoint(geom, parent) {
      var transGeomList = new _ArrayList.default();

      for (var i = 0; i < geom.getNumGeometries(); i++) {
        var transformGeom = this.transformPoint(geom.getGeometryN(i), geom);
        if (transformGeom === null) continue;
        if (transformGeom.isEmpty()) continue;
        transGeomList.add(transformGeom);
      }

      return this._factory.buildGeometry(transGeomList);
    }
  }, {
    key: "transformMultiPolygon",
    value: function transformMultiPolygon(geom, parent) {
      var transGeomList = new _ArrayList.default();

      for (var i = 0; i < geom.getNumGeometries(); i++) {
        var transformGeom = this.transformPolygon(geom.getGeometryN(i), geom);
        if (transformGeom === null) continue;
        if (transformGeom.isEmpty()) continue;
        transGeomList.add(transformGeom);
      }

      return this._factory.buildGeometry(transGeomList);
    }
  }, {
    key: "copy",
    value: function copy(seq) {
      return seq.copy();
    }
  }, {
    key: "transformGeometryCollection",
    value: function transformGeometryCollection(geom, parent) {
      var transGeomList = new _ArrayList.default();

      for (var i = 0; i < geom.getNumGeometries(); i++) {
        var transformGeom = this.transform(geom.getGeometryN(i));
        if (transformGeom === null) continue;
        if (this._pruneEmptyGeometry && transformGeom.isEmpty()) continue;
        transGeomList.add(transformGeom);
      }

      if (this._preserveGeometryCollectionType) return this._factory.createGeometryCollection(_GeometryFactory.default.toGeometryArray(transGeomList));
      return this._factory.buildGeometry(transGeomList);
    }
  }, {
    key: "transform",
    value: function transform(inputGeom) {
      this._inputGeom = inputGeom;
      this._factory = inputGeom.getFactory();
      if (inputGeom instanceof _Point.default) return this.transformPoint(inputGeom, null);
      if (inputGeom instanceof _MultiPoint.default) return this.transformMultiPoint(inputGeom, null);
      if (inputGeom instanceof _LinearRing.default) return this.transformLinearRing(inputGeom, null);
      if (inputGeom instanceof _LineString.default) return this.transformLineString(inputGeom, null);
      if (inputGeom instanceof _MultiLineString.default) return this.transformMultiLineString(inputGeom, null);
      if (inputGeom instanceof _Polygon.default) return this.transformPolygon(inputGeom, null);
      if (inputGeom instanceof _MultiPolygon.default) return this.transformMultiPolygon(inputGeom, null);
      if (inputGeom instanceof _GeometryCollection.default) return this.transformGeometryCollection(inputGeom, null);
      throw new _IllegalArgumentException.default("Unknown Geometry subtype: " + inputGeom.getClass().getName());
    }
  }, {
    key: "transformLinearRing",
    value: function transformLinearRing(geom, parent) {
      var seq = this.transformCoordinates(geom.getCoordinateSequence(), geom);
      if (seq === null) return this._factory.createLinearRing(null);
      var seqSize = seq.size();
      if (seqSize > 0 && seqSize < 4 && !this._preserveType) return this._factory.createLineString(seq);
      return this._factory.createLinearRing(seq);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return GeometryTransformer;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return GeometryTransformer;
}();

exports.default = GeometryTransformer;

GeometryTransformer.constructor_ = function () {
  this._inputGeom = null;
  this._factory = null;
  this._pruneEmptyGeometry = true;
  this._preserveGeometryCollectionType = true;
  this._preserveCollections = false;
  this._preserveType = false;
};